import * as React from "react";
const Svg16PxPolyLine = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "data-name": "Layer 1", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.12 3.63 3.61 13.1l-.74-.73 9.5-9.47z", style: {
  fill: "currentColor"
} }));
export default Svg16PxPolyLine;
